<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-inventory-data modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>เพิ่มคลังสินค้าจากข้อมูลส่วนกลาง</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <product-lookup-master v-if="step === 1" @selectedProduct="setupProductData($event)"></product-lookup-master>     

                        <section class="form-inventory" v-if="step === 2 && productData && formInventory && errorData">
                            <div class="filter mb-3">
                                <div class="product">
                                    <div class="name">
                                        <img :src="productData.brandLogo" class="brand" v-if="productData.brandLogo" />
                                        <span class="brand-text" v-if="!productData.brandLogo">{{ productData.brand }}</span>
                                        <h4>{{ productData.name }}</h4>
                                    </div>
                                </div>

                                <div class="form data">
                                    <div class="field">
                                        <label>SKU / รหัสสินค้า</label>
                                        <input type="text"
                                                v-model="formInventory.sku"
                                                class="input-field text-center"
                                                :class="{ 'invalid': errorData.sku.blank }"
                                                placeholder="SKU / รหัสสินค้า" />
                                    </div>

                                    <div class="field">
                                        <label>ราคาขายสินค้า</label>
                                        <div class="input-price text-right">
                                            <input type="tel" 
                                                    v-model="formInventory.price"
                                                    class="input-field text-center"
                                                    :class="{ 'invalid': errorData.price.blank }"
                                                    @keypress="$AppUtility.inputOnlyNumber($event)"
                                                    placeholder="ราคา" />
                                        </div>
                                        <!-- <div class="suggest text-right">ช่วงราคาในตลาด <span>{{ productData.priceRange }}</span></div> -->
                                    </div>
                                </div>
                            </div>

                            <div class="text-center">
                                <button class="btn btn-main" @click="saveInventory()">บันทึกข้อมูลสินค้า</button>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import ProductLookupMaster from '@/components/utility/ProductLookupMaster';
import DBInventory from '@/database/Inventory';

export default {
    components: {
        ProductLookupMaster
    },
    data() {
        return {
            isActive: false,
            step: 0,
            keyData: null,
            productData: null,
            inventoryData: null,
            formInventory: null,
            errorData: null,
        };
    },
    props: {
        isDisplay: Boolean,
        editData: Object
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.initModal();
            }
        }
    },
    methods: {
        hide() {
            this.step = 0;
            this.$emit('hide', null);
        },
        initModal() {
            if (this.editData) {
                this.keyData = this.editData.key;
                this.productData = this.editData.productData;
                this.inventoryData = this.editData.inventoryData;
                this.proccedStep2();
            } else {
                this.step = 1;
            }

            this.formInventory = this.initFormInventory();
            this.errorData = this.initValidateData();
        },
        initFormInventory() {
            return {
                sku: this.inventoryData ? this.inventoryData.sku : '',
                price: this.inventoryData ? this.inventoryData.price : ''
            };
        },
        initValidateData() {
            return {
                sku: { blank: false },
                price: { blank: false }
            };
        },
        setupProductData(data) {
            this.productData = this.$AppUtility.mapProductDataFromMaster(data);
            this.proccedStep2();
        },
        proccedStep2() {
            if (!Object.prototype.hasOwnProperty.call(this.productData, "masterProductKey")) {
                this.setupProductData(this.productData);
            } else {
                if (!this.inventoryData) {
                    this.formInventory.sku = this.productData.masterProductKey ? this.productData.masterProductKey : '';
                }
                this.step = 2;
            }
        },
        async saveInventory() {
            const loader = this.$AppUtility.renderLoadBackdrop();
            const validateData = await this.validateData();
            loader.hide();

            if (validateData) {
                const inventory = {
                    key: this.keyData,
                    productData: this.productData,
                    inventoryData: this.generateInventoryData()
                };

                this.$emit('hide', inventory);
            }
        },
        generateInventoryData() {
            return {
                sku: this.formInventory.sku,
                price: this.formInventory.price,
                cost: 0
            };
        },
        async validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (typeof this.formInventory[property] === 'string' || this.formInventory[property] instanceof String) {
                    if (!this.formInventory[property].trim()) {
                        this.errorData[property].blank = true;
                        valid = false;
                    }
                }
            }

            const isDuplicateSKU = await this.isDuplicateSKU();

            if (isDuplicateSKU) {
                this.errorData['sku'].blank = true;
                valid = false;

                this.$swal({
                    title: 'SKU นี้ถูกใช้ไปแล้ว โปรดตรวจสอบใหม่อีกครั้ง',
                    icon: 'warning'
                });
            }

            return valid;
        },
        async isDuplicateSKU() {
            let isExist = false;
            const inventory = await DBInventory.get();

            if (inventory.content.findIndex(x => x.inventoryData.sku === this.formInventory.sku) > -1) {
                isExist = true;
            }

            return isExist;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.modal-inventory-data {
    max-width: 800px;

    .form-inventory {
        .filter {
            display: flex;
            justify-content: space-between;

            @media only screen and (max-width: $screenExtraSmall) {
                flex-direction: column;
            }

            .product {
                width: 60%;

                @media only screen and (max-width: $screenExtraSmall) {
                    width: 100%;
                    margin-bottom: 20px;
                }

                .name {
                    .brand {
                        width: auto;
                        max-width: 100%;
                        height: 25px;
                        margin: 0 0 10px;
                    }

                    .brand-text {
                        display: block;
                        font-size: 12px;
                        opacity: 0.6;
                        margin: 0 0 10px;
                    }
                    
                    h4 {
                        font-size: 15px;
                        margin: 0;
                    }
                }
            }

            .data {
                width: 40%;
                padding-left: 20px;

                @media only screen and (max-width: $screenExtraSmall) {
                    width: 100%;
                    padding-left: 0;
                }

                .suggest {
                    display: block;
                    width: 100%;
                    font-size: 13px;
                    color: $textLightColor;
                    padding-top: 5px;
                    margin-right: 5px;

                    span {
                        font-weight: bold;
                        white-space: nowrap;
                        color: $secondaryColor;
                    }
                }
            }
        }
    }
}
</style>